import React, { useEffect, useState, useContext } from "react";
import { Toaster, toast } from "sonner";
import "./pages.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import CommonLoader from "../../../loader/CommonLoader";
import { MdDelete } from "react-icons/md";
import { TbEdit, TbRestore } from "react-icons/tb";
import { Tooltip as ReactTooltip } from "react-tooltip";
import CommonHeader from "../common-components/CommonHeader";
import axiosInstance from "../../../refershTokenManage/axiosConfig";
import { hasPermission } from "../../../helperPermissionEditor";
import { LoginContext } from "../../../App";
import PaginationComponent from "../common-components/pagination/PaginationComponent";
import { Link, useNavigate } from "react-router-dom";
import { clientHeadings } from "../../../utils/constants";
import CustomModal from "../common-components/customModal";
import { FaUserPlus } from "react-icons/fa";
import DeleteModal from "../common-components/deleteModal";
import NoDataFoundPage from "../common-components/NoDataFound";
import GlobalFilter from "./component/GlobalFilter";
import Badge from "react-bootstrap/Badge";
import ForgotPasswordModal from "../common-components/ForgotPassword";

const userData = {
  name: "",
  email: "",
  phone: "",
  password: "",
  address: "",
  tiktok: "",
  status: "",
  id: "",
  tiktok_account_limit: 0
};

const ClientListing = ({ onUserSelect }) => {
  const { user, theme } = useContext(LoginContext),
    [client, setClient] = useState([]),
    [isEditing, setIsEditing] = useState(false),
    [isLoading, setIsLoading] = useState(false),
    [searchQuery, setSearchQuery] = useState(""),
    [editedStatus, setEditedStatus] = useState(""),
    [selectedClientId, setSelectedClientId] = useState(null),
    [currentPage, setCurrentPage] = useState(1),
    [totalPages, setTotalPages] = useState(1),
    [pageStart, setPageStart] = useState(1),
    [newUser, setNewUser] = useState(userData),
    [list, setList] = useState([]),
    [show, setShow] = useState(false),
    [selectedRecord, setSelectedRecord] = useState({
      id: "",
      modal: false,
    }),
    [edit, setEdit] = useState(""),
    [view, setView] = useState({
      visible: false,
    }),
    [addEditModal, setAddEditModal] = useState(false),
    navigate = useNavigate(),
    [handleRestore, setHandleRestore] = useState(false),
    role = localStorage.getItem("userRole"),
    hasAccountManagerRole = role === "account-manager",
    hasAdminRole = role === "super-admin" || role === "admin",
    [handleConfirmationModal, setHandleConfirmationModal] = useState(false),
    [apiData, setApiData] = useState(null),
    [userConfirmed, setUserConfirmed] = useState(null),
    [perPage, setPerPage] = useState(10),
    [filters, setFilters] = useState({
      account_manager_id: "",
      search: "",
      email: "",
      date_from: "",
      date_to: "",
      status: "",
    }),
    [filterModal, setFilterModal] = useState(false),
    [accountManagers, setAccountManagers] = useState([]),
    [isButtonDisabled, setIsButtonDisabled] = useState(false),
    [limitAccountsMessage, setLimitAccountsMessage] = useState(""),
    [forgotPasswordModal, setForgotPasswordModal] = useState({
      show: false,
      email: ""
    });

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const resetFields = () => {
    setNewUser(userData);
    setList([]);
  };

  const handleEditList = (e, record) => {
    setEdit(record);

    setNewUser((prevState) => ({
      ...prevState,
      tiktok: record.tiktok,
    }));
    setEditedStatus(record.status);
  };

  const handleDeleteList = async (e, record) => {
    const token = localStorage.getItem("token");
    setIsLoading(true);

    try {
      await axiosInstance.delete(
        `/api/tiktoks/${record.id}`,
        {
          params: {
            client_id: record.client_id,
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      getTiktoks(record.client_id);
      toast.success("TikTok account deleted successfully!");
    } catch (error) {
      setList(list);
      toast.error("Error deleting TikTok account");
    } finally {
      setIsLoading(false);
    }
  };

  const handleRestoreTiktok = async (e, record) => {
    const token = localStorage.getItem("token");
    setIsLoading(true);
    try {
      await axiosInstance.put(
        `/api/tiktoks/${record.id}/restore`,
        {
          client_id: record.client_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("TikTok account restored successfully!");
      getTiktoks(record.client_id);
      setHandleRestore(false);
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Error restoring TikTok account"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setShow(false);
    resetFields();
    setView({});
    setEditedStatus("");
    setEdit("");
    setAddEditModal(false);
    setFilterModal(false);
  };

  const fetchClient = async (page = 1) => {
    const token = localStorage.getItem("token");
    setIsLoading(true);
    try {
      if (filters) {
        setFilterModal(false);
      }
      const params = new URLSearchParams({
        page,
        ...filters,
        status: String(filters.status)  // Explicitly convert status to string
      }).toString();
      const response = await axiosInstance.get(`/api/clients?${params}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setClient(response.data.clients);
      setTotalPages(response.data.pagination.last_page);
      setPerPage(response.data.pagination.per_page);
      setAccountManagers(response.data.account_managers);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
    setIsLoading(false); // End loading
  };

  const getTiktoks = async (id) => {
    const token = localStorage.getItem("token");
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(`/api/tiktoks`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          client_id: id,
        },
      });

      if (response.data?.tiktoks.length) {
        setList(response?.data?.tiktoks);
      }
    } catch (error) {
      console.error("Error fetching TikTok accounts:", error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchClient(currentPage);
    const intervalId = setInterval(() => {
      fetchClient();
    }, 300000);

    return () => clearInterval(intervalId);
  }, [currentPage, filters]);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    const newPageStart = Math.floor((page - 1) / 5) * 5 + 1;
    setPageStart(newPageStart);
  };

  const handleEdit = (record) => {
    setShow(true);
    setAddEditModal(true);

    setNewUser({
      name: record.name,
      email: record.email,
      phone: record.phone,
      address: record.address,
      user_id: record.user_id,
      status: record.status === "In-Active" ? "0" : "1",
      id: record.id,
      tiktok_account_limit: record.tiktok_account_limit
    });
    setEditedStatus(record.status);
  };

  const handleView = async (record) => {
    const { tiktoks } = record;
    let client_id;
    if (tiktoks.length) {
      client_id = tiktoks[0]?.client_id;
    } else {
      client_id = record.id;
    }
    await getTiktoks(client_id);

    setView({
      clientId: client_id,
      visible: true,
    });
    setShow(true);
  };

  const handleDeleteAPICall = async (clientId) => {
    const token = localStorage.getItem("token");

    setIsLoading(true); // Start loading
    try {
      await axiosInstance.delete(`/api/clients/${clientId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setClient(client?.filter((user) => user.id !== clientId));
      toast.success("User deleted successfully!");
      setSelectedRecord({
        id: "",
        modal: false,
      });
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("token");
        localStorage.clear();
        navigate("/");
      } else {
        console.error("Error deleting user:", error);
        toast.error("Error deleting user");
      }
    }
    setIsLoading(false); // End loading
  };

  const handleUpdateClientAPI = async () => {
    const token = localStorage.getItem("token");
    const updatedUserData = {
      name: newUser.name,
      user_id: Number(newUser.id),
      email: newUser.email,
      phone: Number(newUser.phone),
      address: newUser.address,
      status: newUser.status,
      tiktok_account_limit: Number(newUser.tiktok_account_limit)
    };
    try {
      const response = await axiosInstance.put(
        `/api/clients/${newUser.id}`,
        updatedUserData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setIsEditing(false);
      toast.success("client updated successfully");
      handleClose();
      fetchClient();

      if (response.status === 201) {
        setIsEditing(false);
        setEditedStatus("");
      } else {
        console.error("Error updating user:", response);
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("please try again ");
    }
  };

  const handleCreateClientAPI = async (event) => {
    const { tiktok, ...rest } = newUser;
    const { name, phone, address } = rest;

    // Check if any of the fields are empty
    if (!name.trim() || !phone.trim() || !address.trim()) {
      toast.error("Please fill in all the fields before submitting.");
      return; // Prevent the API call
    }

    setIsLoading(true);
    const token = localStorage.getItem("token");
    const clientPayload = {
      ...rest,
      phone: Number(phone),
    };
    try {
      await axiosInstance.post(`/api/clients`, clientPayload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setIsLoading(false);
      handleClose();
      fetchClient();
      toast.success("Client created successfully");
    } catch (error) {
      setIsLoading(false); // Ensure loading is set to false in case of error
      toast.error(error.response.data.message);
      console.error("Error creating user:", error);
    }
  };

  const filteredClients = client?.filter((client) =>
    client.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const addTiktokAccountsAPICall = async () => {
    const { tiktok } = newUser;

    if (!tiktok) {
      toast.error("Please fill in the fields before submitting.");
      return;
    }

    setIsLoading(true);
    const token = localStorage.getItem("token");
    const payload = {
      client_id: view?.clientId,
      tiktok,
    };

    try {
      let apiResponse;

      if (edit) {
        apiResponse = await axiosInstance.put(
          `/api/tiktoks/${edit.id}`,
          {
            ...payload,
            status: editedStatus,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        apiResponse = await axiosInstance.post(`/api/tiktoks`, payload, {});
      }

      if (apiResponse.data.flag === true && hasAccountManagerRole) {
        setApiData({
          clientId: view?.clientId,
          tiktokId: apiResponse.data.pivot.tiktok_id,
        });
        setHandleConfirmationModal(true);
      }

      setIsLoading(false);
      setEdit("");
      setEditedStatus("");
      setNewUser((prevState) => ({
        ...prevState,
        tiktok: "",
      }));

      getTiktoks(view?.clientId);
      toast.success(`${edit ? "Updated" : "Created"} successfully`);
    } catch (error) {
      setIsLoading(false);
      toast.error(error.response?.data?.message || "Something went wrong");
      console.error("Error while creating/updating:", error);
    }
  };

  const onConfirmationModal = async (confirmation) => {
    setHandleConfirmationModal(false);
    setIsLoading(true);

    try {
      await axiosInstance.post(`/api/accountManagers/update-flag-to-see-old-details`, {
        client_id: apiData.clientId,
        tiktok_id: apiData.tiktokId,
        flag: confirmation ? 1 : 0,
      });
      toast.success("Data updated successfully!");
    } catch (error) {
      toast.error("Failed to update data.");
    } finally {
      setIsLoading(false);
    }
  };

  const getClientLimit = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axiosInstance.post("/api/client/limit", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setIsButtonDisabled(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setIsButtonDisabled(true);
        setLimitAccountsMessage(error.response.data.message);
        console.error("TikTok account limit reached:", error.response.data.message);
      } else {
        console.error("Error fetching TikTok account limit:", error);
      }
    }
  };

  const clientFormUI = () => {
    return (
      <Form>
        <Form.Group controlId="exampleForm.ControlInput1" className="mb-3">
          <Form.Control
            type="text"
            placeholder="Enter Your Name "
            autoFocus
            className="creatuserListing"
            value={newUser.name}
            onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
            required
          />
        </Form.Group>
        <Form.Group controlId="formBasicEmail" className="mb-3">
          <Form.Control
            type="email"
            placeholder="Enter email"
            value={newUser.email}
            onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
          />
        </Form.Group>

        {!editedStatus && (
          <Form.Group controlId="formBasicPassword" className="mb-3">
            <Form.Control
              type="password"
              placeholder="Enter password"
              value={newUser.password}
              onChange={(e) =>
                setNewUser({ ...newUser, password: e.target.value })
              }
            />
          </Form.Group>
        )}

        <Form.Group controlId="exampleForm.ControlInput2" className="mb-3">
          <Form.Control
            type="number"
            placeholder="Mobile number"
            autoFocus
            className="creatuserListing"
            value={newUser.phone}
            onChange={(e) => setNewUser({ ...newUser, phone: e.target.value })}
            required
          />
        </Form.Group>

        <Form.Group controlId="exampleForm.ControlInput4" className="mb-3">
          <Form.Control
            type="text"
            autoFocus
            value={newUser.address}
            onChange={(e) =>
              setNewUser({ ...newUser, address: e.target.value })
            }
            required
            placeholder="Address"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <select
            className="form-select"
            value={newUser.status}
            onChange={(e) => {
              setNewUser({
                ...newUser,
                status: e.target.value,
              });
            }}
          >
            <option value="1">Active</option>
            <option value="0">In-Active</option>
          </select>
        </Form.Group>
        {hasAdminRole && editedStatus && (
          <Form.Group className="mb-3">
            <Form.Control
              type="number"
              autoFocus
              value={newUser.tiktok_account_limit}
              onChange={(e) =>
                setNewUser({ ...newUser, tiktok_account_limit: e.target.value })
              }
              required
              placeholder="TikTok Account Limit"
            />
          </Form.Group>
        )}
        {isButtonDisabled && (
          <p className="mt-3 mb-3 font-weight-bold"><small className="">{limitAccountsMessage}</small></p>
        )}
      </Form>
    );
  };

  const addEditTiktokAccounts = () => {
    return (
      <div class="mt-3 ">
        <Form.Group
          className="addToMoreList mb-3"
          controlId="exampleForm.ControlInput3"
        >
          <Form.Control
            type="text"
            autoFocus
            style={{ display: "inline-block" }}
            value={newUser.tiktok}
            onChange={(e) =>
              setNewUser((prevState) => ({
                ...prevState,
                tiktok: e.target.value,
              }))
            }
            required
            placeholder="Tiktok@id"
            disabled={edit?.tiktok}
          />
        </Form.Group>

        {editedStatus && (
          <div class="d-flex justify-content-around">
            {activeInActiveUI()}
            <button
              class="btn btn-danger"
              style={{ marginLeft: "10px" }}
              onClick={() => {
                setEditedStatus(false);
                setNewUser((prevState) => ({
                  ...prevState,
                  tiktok: "",
                }));
                setEdit("");
              }}
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    );
  };
  function activeInActiveUI() {
    return (
      <select
        className="mr-2"
        style={{
          padding: "10px",
          backgroundColor: "white",
          border: "none",
          width: "100%",
        }}
        value={editedStatus}
        onChange={(e) => {
          setEditedStatus(e.target.value);
        }}
      >
        <option value="1">Active</option>
        <option value="0">In-Active</option>
      </select>
    );
  }

  const handleForgotPassword = (email) => {
    setForgotPasswordModal({
      show: true,
      email: email
    });
  };

  return (
    <div className=" clientLists userLists">
      <CommonHeader
        dashboardName={"Client"}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        handleShow={() => {
          setShow(true);
          setAddEditModal(true);
        }}
        user={user}
      />
      <Button
        variant="primary"
        onClick={() => {
          setFilterModal(true);
        }}
        className="mt-3"
      >
        Filter
      </Button>
      <div className="mt-3">
        <div className="userFetchData">
          <div className="userDetails">
            <div className="rounded overflow-hidden shadow">
              <div class="border-0 table-container sm-table table-responsive">
                <table
                  className={`table-responsive table table-bordered table-striped overflow-auto table-hover${theme === "dark" ? " dark-table" : ""
                    }`}
                >
                  <thead>
                    <tr>
                      {clientHeadings.map((heading) => (
                        <th
                          className={`${heading === "Action" ? "text-center" : ""
                            }`}
                        >
                          {heading}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredClients.length > 0 ? (
                      filteredClients.map((client, index) => (
                        <tr
                          key={client.id}
                          style={{
                            backgroundColor: index % 2 === 0 ? "#fff" : "#f2f2f2",
                          }}
                        >
                          <td data-th={clientHeadings[0]}>
                            {(currentPage - 1) * perPage + index + 1}
                          </td>
                          <td data-th={clientHeadings[1]} >{client.name}</td>
                          <td data-th={clientHeadings[2]}>
                            <span
                              style={{
                                cursor: "pointer",
                                color: theme === "dark" ? "#94abff" : "#0d6efd",
                              }}
                              onClick={() => handleForgotPassword(client.email)}
                            >
                              {client.email}
                            </span>
                          </td>
                          <td data-th={clientHeadings[3]}>{client.phone}</td>
                          <td data-th={clientHeadings[4]}>{client.address}</td>
                          <td data-th={clientHeadings[5]}>
                            <Badge data-tooltip-id={`created-by-role-${client.id}`} bg="gypsi-info">{client.created_by}</Badge>
                            <ReactTooltip
                              id={`created-by-role-${client.id}`}
                              place="bottom"
                              content={"Created By: " + client.created_by_role ?? "N/A"}
                            />
                          </td>
                          <td data-th={clientHeadings[6]}>{client.created_at}</td>

                          <td className="" data-th={clientHeadings[10]}>
                            {client.name === "Super Admin" ? (
                              <span className="fs-6">
                                Admin user is not Viewable
                              </span>
                            ) : (
                              <span className="d-sm-flex justify-content-center">
                                {/* view tiktok accounts */}
                                <button
                                  data-tooltip-id="add-tiktok-accounts"
                                  className="add me-1"
                                  onClick={() => handleView(client)}
                                >
                                  <FaUserPlus />
                                </button>
                                <ReactTooltip
                                  id="add-tiktok-accounts"
                                  place="bottom"
                                  content="Add TikTok Account"
                                />

                                {hasPermission(
                                  user.permissions,
                                  "update-client"
                                ) && (
                                    <button
                                      data-tooltip-id="Edit-button"
                                      className="edit me-1"
                                      onClick={() => handleEdit(client)}
                                    >
                                      <TbEdit />
                                    </button>
                                  )}
                                <ReactTooltip
                                  id="Edit-button"
                                  place="bottom"
                                  content="Edit Client"
                                />
                                <Toaster position="top-center" richColors />

                                {hasPermission(
                                  user.permissions,
                                  "delete-client"
                                ) && (
                                    <button
                                      data-tooltip-id="delete-button"
                                      className="delete me-1"
                                      onClick={() => {
                                        setSelectedRecord({
                                          id: client.id,
                                          modal: true,
                                        });
                                      }}
                                    >
                                      <MdDelete />
                                    </button>
                                  )}
                                <ReactTooltip
                                  id="delete-button"
                                  place="bottom"
                                  content="Delete Client"
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          <NoDataFoundPage />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div>
            {totalPages > 1 && (
              <div className="pagination">
                <PaginationComponent
                  currentPage={currentPage}
                  totalPages={totalPages}
                  handlePageChange={handlePageChange}
                  pageStart={pageStart}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      <DeleteModal
        toggleState={selectedRecord?.modal}
        toggleHandler={() => setSelectedRecord(false)}
        apiCallHandleronClick={() => handleDeleteAPICall(selectedRecord?.id)}
      />

      {/* Add / Edit / View Modal */}
      <CustomModal
        show={show}
        handleClose={handleClose}
        headerContent={
          view?.visible ? (
            <h4 className="create_user_heading">Tiktok Accounts</h4>
          ) : (
            addEditModal && (
              <div>
                <h4 className="create_user_heading">
                  {editedStatus ? "Update" : "Add"} Client
                </h4>
                <p className=" fs-5 mt-3 text-muted">
                  Client to manage and view your profile
                </p>
              </div>
            )
          )
        }
        bodyContent={
          view.visible ? (
            <>
              {addEditTiktokAccounts()}
              {list.length > 0 && (
                <div className="border-0 tiktoksounds table-responsive" style={{ width: "100%", overflow: "auto" }}>
                  <table
                    class={`table-responsive table table-bordered table-striped overflow-auto table-hover${theme === "dark" ? " table-dark" : ""}`}
                  >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list?.map((record, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>
                            <Link to={`/Tiktok-statistics/${record?.id}`}>
                              {record.tiktok}
                            </Link>
                          </td>

                          <td>{Number(record.status) ? "Active" : "InActive"}</td>

                          <td>
                            <button
                              class="edit"
                              onClick={(e) =>
                                record.deleted_at
                                  ? handleRestoreTiktok(e, record)
                                  : handleEditList(e, record)
                              }
                              disabled={edit?.tiktok}
                            >
                              {record.deleted_at ? <TbRestore /> : <TbEdit />}
                            </button>
                            {/* TODO: */}
                            <button
                              class="delete"
                              onClick={(e) => handleDeleteList(e, record)}
                              disabled={record?.deleted_at ? "disabled" : ""}
                            >
                              <MdDelete />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          ) : addEditModal ? (
            clientFormUI()
          ) : (
            ""
          )
        }
        footerContent={
          <>
            {view.visible ? (
              <Button
                variant="primary"
                className="creatrUserSubmit"
                onClick={addTiktokAccountsAPICall}
              >
                {edit?.tiktok ? `Update TikTok` : `Add TikTok`} Account
              </Button>
            ) : addEditModal ? (
              <Button
                variant="primary"
                className="creatrUserSubmit"
                onClick={
                  editedStatus ? handleUpdateClientAPI : handleCreateClientAPI
                }
                disabled={isLoading || (editedStatus ? false : isButtonDisabled)}
              >
                {editedStatus ? "Update" : "Add"} Client
              </Button>
            ) : (
              ""
            )}
            <Button
              variant="secondary"
              className="creatrUserClose"
              onClick={handleClose}
            >
              Close
            </Button>
          </>
        }
      />
      {isLoading && (
        <div className="loader-overlay">
          <CommonLoader />
        </div>
      )}
      {/* Confirmation Modal */}
      <CustomModal
        show={handleConfirmationModal}
        handleClose={() => setHandleConfirmationModal(false)}
        headerContent={<h4>Confirm Your Choice</h4>}
        bodyContent={<p>Do you want to proceed with old data? Or need to start from scratch?</p>}
        footerContent={
          <>
            <Button
              variant="danger"
              onClick={() => onConfirmationModal(true)}
              disabled={isLoading}
            >
              {isLoading ? "Updating..." : "Yes"}
            </Button>
            <Button
              variant="secondary"
              onClick={() => onConfirmationModal(false)}
            >
              No
            </Button>
          </>
        }
      />
      {/* Filters Modal */}
      <CustomModal
        show={filterModal}
        handleClose={() => setFilterModal(false)}
        headerContent={<h4>Filters</h4>}
        bodyContent={
          <GlobalFilter
            parentFilters={filters}
            accountManagers={accountManagers}
            onFilterChange={handleFilterChange}
            isAdmin={hasAdminRole}
            module={"clients"}
          />
        }
        footerContent={<></>}
      />
      {/* Forgot Password Modal */}
      <ForgotPasswordModal
        show={forgotPasswordModal.show}
        handleClose={() => setForgotPasswordModal({ show: false, email: "" })}
        userEmail={forgotPasswordModal.email}
      />
    </div>
  );
};

export default ClientListing;
